import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { maxSuggestedTags } from '@config';

const StyledTopTagsContainer = styled.div`
  margin-bottom: 40px;
  text-align: center;

  .tags-list {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px 20px;

    .tag-link {
      ${({ theme }) => theme.mixins.linkButton};
    }
  }
`;
const StyledSearchBarContainer = styled.div`
  ${({ theme }) => theme.mixins.searchBar};
`;

const PensieveHeader = ({ data, searchTerm, setSearchTerm, setSelectedTag, setCurrentPage }) => {
  const allPosts = data.allMarkdownRemark.edges;

  const topTags = useMemo(() => {
    const tagCounts = {};
    allPosts.forEach(({ node }) => {
      node.frontmatter.tags.forEach(tag => {
        tagCounts[tag] = (tagCounts[tag] || 0) + 1;
      });
    });
    return Object.entries(tagCounts)
      .sort(([, countA], [, countB]) => countB - countA)
      .slice(0, maxSuggestedTags)
      .map(([tag]) => tag);
  }, [allPosts]);

  const handleTagClick = tag => {
    setSelectedTag(tag);
    setCurrentPage(1);
  };

  const handleClearTagFilter = () => {
    setSelectedTag(null);
    setCurrentPage(1);
  };

  const handleSearchChange = event => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  return (
    <React.Fragment>
      <header>
        <h1 className="big-heading">Pensieve</h1>
        <p className="subtitle">
          <a href="https://humanornot.so/">
            a collection of memories
          </a>
        </p>
      </header>

      <StyledSearchBarContainer>
        <input
          type="text"
          placeholder="Search memories by title or tag..."
          value={searchTerm}
          onChange={handleSearchChange}
          aria-label="Search posts by title or tag"
        />
      </StyledSearchBarContainer>

      {topTags.length > 0 && (
        <StyledTopTagsContainer>
          <div className="tags-list">
            <button className="tag-link"
              onClick={handleClearTagFilter}>
              All Posts
            </button>
            {topTags.map(tag => (
              <button className="tag-link" key={tag}
                onClick={() => handleTagClick(tag)}>
                #{tag}
              </button>
            ))}
          </div>
        </StyledTopTagsContainer>
      )}
    </React.Fragment>
  );
};

PensieveHeader.propTypes = {
  data: PropTypes.object.isRequired,
  searchTerm: PropTypes.string.isRequired,
  setSearchTerm: PropTypes.func.isRequired,
  setSelectedTag: PropTypes.func.isRequired,
  setCurrentPage: PropTypes.func.isRequired,
};

export default PensieveHeader;